import './common/errorHandle'
import Vue from 'vue'
import { Locale } from 'vant'
// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import MetaInfo from 'vue-meta-info'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import './libs/element'
import jquery from 'jquery/dist/jquery'
import NP from './libs/number-precision'
import store from './store'
import filters from './common/filter'
import router from './router'
import './common/directive'
import globalMixin from './mixins/global'
import tableScroll from './mixins/tableScroll'
import 'normalize.css'
import './assets/styles/index.less'
import './assets/icon/iconfont.css'
import 'wangeditor/release/wangEditor.min.css'
import '@/common/component'
import i18n from './lang'
import SortTableFiltersDlg from './components/SortTableFiltersDlg.vue'
import '@/util/checkVersion'

Vue.prototype.$t1 = function $t1(...args) { // 解决this.$t返回不是string类型问题
    return this.$t(...args) + ''
}

Locale.use('en-US', enUS)

Vue.component('SortTableFiltersDlg', SortTableFiltersDlg)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(Viewer)
Vue.use(MetaInfo)
window.jQuery = jquery
window.jquery = jquery
window.$ = jquery
window.NP = NP                   // 精确数学计算
window.hljs = {loaded: true}     // 赋值代码高亮变量，避免wangeditor富文本控件多余加载
window.$i18n = i18n

Object.keys(filters).forEach((k: any): void => {     // 定义全局过滤器
    Vue.filter(k, filters[k])
})

Vue.mixin(globalMixin)          // 注册全局mixin
Vue.mixin(tableScroll)

window.$AppMain = new Vue({
    el: '#app',
    name: 'Root',
    router,
    i18n,
    store,
})
